import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AgGridModule } from 'ag-grid-angular';
import { EffectsModule } from '@ngrx/effects';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { TreeViewModule } from '@progress/kendo-angular-treeview';

import { ResearchRoutingModule } from './research-routing.module';

import { WidgetsModule } from '../../widgets/widgets.module';
import { ThreadListEffects } from '../../tamalelibs/redux/thread-list.effects';
import { ResearchComponentModule } from '../../components/research-component.module';
import { ResearchWrapperComponent } from './research-wrapper/research-wrapper.component';

@NgModule({
    imports: [
        AgGridModule,
        CommonModule,
        WidgetsModule,
        DropDownsModule,
        TreeViewModule,
        ResearchRoutingModule,
        InfiniteScrollModule,
        TooltipModule,
        ResearchComponentModule,
        EffectsModule.forFeature([
            ThreadListEffects,
        ]),
    ],
    declarations: [
        ResearchWrapperComponent
    ],
    exports: [
        ResearchWrapperComponent
    ]
})
export class ResearchModule { }
